import { createAsyncThunk } from "@reduxjs/toolkit";
import { Page } from "../../api-model/api";
import { CoreRequest } from "../../config/serviceInstances";
import { WorkContractTaskParams, WorkContractTaskStatus } from "./tasks";
import { TemplateType } from "../../organization/companies/detail/dpf";
import { EmployeeAvatarDto } from "../../api-model/organization/company";
import { ActionType, handleActionWithFeedback } from "../../store/errors";

export interface WorkContractSubTask {
  uuid: string;
  dueDate: string;
  status: WorkContractTaskStatus;
  category: string | TemplateType;
  assigneeWorkContractId: string;
  assignee: EmployeeAvatarDto;
  subject: EmployeeAvatarDto;
  description: string;
  companyId: string;
  taskProjectId: string;
}

export const listWorkContractSubTasks = createAsyncThunk<
  Page<WorkContractSubTask>,
  { uuid?: string; requestParameter: WorkContractTaskParams }
>("/employees/contract/sub-tasks", async ({ uuid, requestParameter }) => {
  const { data } = await CoreRequest.get("/contracts/sub-tasks", {
    params: {
      ...requestParameter,
      workContractId: uuid,
    },
  });

  return data;
});

export const deleteWorkContractSubTask = createAsyncThunk<
  WorkContractSubTask,
  string
>("/employees/contract/sub-tasks/delete", async (uuid, thunkApi) => {
  return handleActionWithFeedback<WorkContractSubTask>(
    () => CoreRequest.delete(`/contracts/sub-tasks/${uuid}`),
    thunkApi,
    ActionType.delete,
    "resource.subTask"
  );
});

export const updateWorkContractSubTask = createAsyncThunk<
  WorkContractSubTask,
  WorkContractSubTask
>("/employees/contract/sub-tasks/update", async (rp, thunkApi) => {
  return handleActionWithFeedback<WorkContractSubTask>(
    () => CoreRequest.put(`/contracts/sub-tasks`, rp),
    thunkApi,
    ActionType.update,
    "resource.subTask"
  );
});

export const createWorkContractSubTask = createAsyncThunk<
  WorkContractSubTask,
  {
    contractId: string;
    taskId: string;
    payload: WorkContractSubTask;
  }
>(
  "/employees/contract/sub-tasks/create",
  async ({ contractId, taskId, payload }, thunkApi) => {
    return handleActionWithFeedback<WorkContractSubTask>(
      () =>
        CoreRequest.post(`/contracts/${contractId}/sub-tasks/${taskId}`, {
          ...payload,
          status: WorkContractTaskStatus.OPEN,
        }),
      thunkApi,
      ActionType.create,
      "resource.subTask"
    );
  }
);
